<script setup lang="ts">
import type { StrapiBlockInlineText } from '@nimbus/types'
import { computed } from '#imports'

const props = defineProps<StrapiBlockInlineText>()

const hasModifier = computed(() => props.bold || props.code || props.italic || props.strikethrough || props.underline)

const classNames = computed(() => {
    const classes = ['text']

    if (props.italic) classes.push('text--italic')
    if (props.strikethrough) classes.push('text--strikethrough')
    if (props.underline) classes.push('text--underline')

    return classes
})
</script>

<template>
    <!-- eslint-disable vue/no-v-html props.text is safe -->
    <template v-if="hasModifier">
        <code
            v-if="props.code"
            :class="classNames"
            v-html="props.text"
        />
        <strong
            v-else-if="props.bold"
            :class="classNames"
            v-html="props.text"
        />
        <span
            v-else
            :class="classNames"
            v-html="props.text"
        />
    </template>

    <template v-else-if="!props.text">
        <br>
    </template>

    <template v-else>
        <span v-html="props.text" />
    </template>
    <!-- eslint-enable vue/no-v-html -->
</template>

<style scoped lang="scss">
.text {
    &--italic {
        font-style: italic;
    }

    &--strikethrough {
        text-decoration: line-through;
    }

    &--underline {
        text-decoration: underline;
    }
}
</style>
